import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as uuid from 'uuid';

export class SubSink {
  protected _subs: any;

  constructor() {
    this._subs = {};
  }

  set sink(subscription: Subscription) {
    this._subs[uuid.v4()] = subscription;
  }

  unsubscribeAll() {
    Object.keys(this._subs).map((key) => {
      this._subs[key].unsubscribe();
    });
  }
}

@Directive()
export abstract class SubscriptionHandlerDirective implements OnDestroy {
  subs = new SubSink();

  ngOnDestroy() {
    this.subs.unsubscribeAll();
  }
}
